import { createAction } from 'redux-actions';
import Web3 from 'web3';
import Logger from 'js-logger';
import { contractAddresses } from '../../../utils';
import { callDataTeamData } from './hooks';
import { getProductionBySecond, getTeamInfo } from '../../../utils/callHelpers';
import PresenterABI from '../../../abi/presenterAbi';

export const updateActiveTeam = createAction('UPDATE_ACTIVE_TEAM');
export const updateAttackTeam = createAction('UPDATE_ATTACK_TEAM');
export const updateAttacking = createAction('UPDATE_ATTACKING');

export const setActiveTeam = (team) => (dispatch) => {
    // TODO: Implement get round data with api

    dispatch(updateActiveTeam(team));
};

export const setAttackTeam = (team) => (dispatch) => {
    dispatch(updateAttackTeam(team));
};

export const isAttacking = (attacking) => (dispatch) => {
    dispatch(updateAttacking(attacking));
};


export const setTeamInfo = createAction('SET_TEAM_INFO');
export const updateTeamInfo = (info) => (dispatch) => {
    dispatch(setTeamInfo(info));
};

export const setRewardAmount = createAction('SET_REWARD_AMOUNT');
export const updateRewardAmount = (info) => (dispatch) => {
    dispatch(setRewardAmount(info));
};

export const getProductionData = async (presenterContract) => {
    try {
        const [dogeInfo, pepeInfo, wojakInfo] = await Promise.all([
            getProductionBySecond(presenterContract, 0),
            getProductionBySecond(presenterContract, 1),
            getProductionBySecond(presenterContract, 2)]
        );

        const total = parseInt(Web3.utils.fromWei(dogeInfo)) + parseInt(Web3.utils.fromWei(pepeInfo)) + parseInt(Web3.utils.fromWei(wojakInfo));

        return {
            total,
            doge: parseFloat(Web3.utils.fromWei(dogeInfo)),
            pepe: parseFloat(Web3.utils.fromWei(pepeInfo)),
            wojak: parseFloat(Web3.utils.fromWei(wojakInfo))
        }
    } catch (err) {
        Logger.error(err)
    }
}

export const getDataTeamInfo = async (presenterContract) => {
    try {
        const [dogeInfo, pepeInfo, wojakInfo] = await Promise.all([
            getTeamInfo(presenterContract, 0),
            getTeamInfo(presenterContract, 1),
            getTeamInfo(presenterContract, 2)]
        );

        const dogeReward = parseFloat(Web3.utils.fromWei(dogeInfo?.rewardAmount));
        const pepeReward = parseFloat(Web3.utils.fromWei(pepeInfo?.rewardAmount));
        const wojakReward = parseFloat(Web3.utils.fromWei(wojakInfo?.rewardAmount));

        const total = dogeReward + pepeReward + wojakReward;
        return {
            total,
            doge: dogeReward,
            pepe: pepeReward,
            wojak: wojakReward
        }

    } catch (err) {
        Logger.error(err)
    }
}

export const getDataTeamInfoAndupdate = () => async (dispatch, getState) => {
    try {
        const account = getState()?.user?.userAccount?.accounts[0];
        const chainId = getState()?.user?.chainId;
        if (account && chainId) {
            const presenterContract = new window.web3.eth.Contract(PresenterABI, contractAddresses(chainId)['PRESENTER']);
            const dataTeamInfo = await callDataTeamData(presenterContract, account);
            dispatch(updateTeamInfo(dataTeamInfo));
        }
    } catch (err) {
        Logger.error(err)
    }
};